"use client"

import { useEffect, useState } from "react"
import QrCodeMessage from "@/components/qr-code-message"
import MenuLoader from "@/components/menu-loader"
import ThemeRenderer from "@/components/theme-renderer"
import { useApp } from "@/lib/context"

export default function Home() {
  const { isValidSession, isSessionExpired } = useApp()
  const [isLoading, setIsLoading] = useState(true)

  // Simular carregamento rápido
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  // Se não há sessão válida ou sessão expirou, mostrar QR code
  if (!isValidSession || isSessionExpired) {
    return <QrCodeMessage />
  }

  return isLoading ? (
    <MenuLoader onComplete={() => setIsLoading(false)} />
  ) : (
    <ThemeRenderer isLoading={isLoading} onLoadingComplete={() => setIsLoading(false)} />
  )
}
